module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_70_80.15a1321b.png";